var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "coachMarkWrapper", staticClass: "coach-mark-wrapper" },
    [
      _c("div", { staticClass: "coach-mark" }, [
        _c("div", { staticClass: "coach-mark-preview" }, [
          _c("div", { staticClass: "coach-mark-preview-video-container" }, [
            _c(
              "div",
              { staticClass: "coach-mark-preview-device-status-container" },
              [
                _c("div", {
                  staticClass: "coach-mark-preview-device-status mic",
                }),
                _c("div", {
                  staticClass: "coach-mark-preview-device-status camera",
                }),
                _c("div", { staticClass: "coach-mark-guide device pc" }, [
                  _c(
                    "div",
                    { staticClass: "coach-mark-guide-text-container" },
                    [
                      _c("p", { staticClass: "coach-mark-guide-title" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("deviceSetting.coachmark.deviceStatus.title")
                          )
                        ),
                      ]),
                      _c("p", { staticClass: "coach-mark-guide-text" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("deviceSetting.coachmark.deviceStatus.text")
                          )
                        ),
                      ]),
                    ]
                  ),
                  _vm._m(0),
                ]),
                _c("div", { staticClass: "coach-mark-guide device mobile" }, [
                  _vm._m(1),
                  _c(
                    "div",
                    { staticClass: "coach-mark-guide-text-container" },
                    [
                      _c("p", { staticClass: "coach-mark-guide-text" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("deviceSetting.coachmark.deviceStatus.check")
                          )
                        ),
                      ]),
                    ]
                  ),
                ]),
              ]
            ),
            _c("div", { staticClass: "coach-mark-guide preview pc" }, [
              _c("div", { staticClass: "coach-mark-guide-text-container" }, [
                _c("p", { staticClass: "coach-mark-guide-title" }, [
                  _vm._v(
                    _vm._s(_vm.$t("deviceSetting.coachmark.preview.title"))
                  ),
                ]),
                _c("p", { staticClass: "coach-mark-guide-text" }, [
                  _vm._v(
                    _vm._s(_vm.$t("deviceSetting.coachmark.preview.text"))
                  ),
                ]),
              ]),
              _vm._m(2),
            ]),
            _c("div", { staticClass: "coach-mark-preview-tabs-container pc" }, [
              _c("div", { staticClass: "coach-mark-preview-tab video" }, [
                _vm._v(_vm._s(_vm.$t("common.video"))),
              ]),
              _c("div", { staticClass: "coach-mark-preview-tab audio" }, [
                _vm._v(_vm._s(_vm.$t("common.audio"))),
              ]),
              _c("div", { staticClass: "coach-mark-guide tab pc" }, [
                _c("div", { staticClass: "coach-mark-guide-text-container" }, [
                  _c("p", { staticClass: "coach-mark-guide-title" }, [
                    _vm._v(_vm._s(_vm.$t("deviceSetting.coachmark.tab.title"))),
                  ]),
                  _c("p", { staticClass: "coach-mark-guide-text" }, [
                    _vm._v(_vm._s(_vm.$t("deviceSetting.coachmark.tab.text"))),
                  ]),
                ]),
                _vm._m(3),
              ]),
            ]),
            _c("div", { staticClass: "coach-mark-guide preview mobile" }, [
              _vm._m(4),
              _c("div", { staticClass: "coach-mark-guide-text-container" }, [
                _c("p", { staticClass: "coach-mark-guide-text" }, [
                  _vm._v(
                    _vm._s(_vm.$t("deviceSetting.coachmark.background.check"))
                  ),
                ]),
              ]),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "coach-mark-preview-virtual-background-container" },
            [
              _c(
                "div",
                {
                  staticClass: "coach-mark-preview-virtual-background blur pc",
                },
                [
                  _c("div", { staticClass: "coach-mark-guide blur" }, [
                    _vm._m(5),
                    _c(
                      "div",
                      { staticClass: "coach-mark-guide-text-container" },
                      [
                        _c("p", { staticClass: "coach-mark-guide-title" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "deviceSetting.coachmark.background.blur.title"
                              )
                            )
                          ),
                        ]),
                        _c("p", { staticClass: "coach-mark-guide-text" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "deviceSetting.coachmark.background.blur.text"
                              )
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ]
              ),
              _c(
                "div",
                { staticClass: "coach-mark-preview-virtual-background img" },
                [
                  _c("div", { staticClass: "coach-mark-guide img pc" }, [
                    _vm._m(6),
                    _c(
                      "div",
                      { staticClass: "coach-mark-guide-text-container" },
                      [
                        _c("p", { staticClass: "coach-mark-guide-title" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "deviceSetting.coachmark.background.image.title"
                              )
                            )
                          ),
                        ]),
                        _c("p", { staticClass: "coach-mark-guide-text" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "deviceSetting.coachmark.background.image.text"
                              )
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ]
              ),
            ]
          ),
        ]),
        _c("div", { staticClass: "coach-mark-footer" }, [
          _c("div", { staticClass: "check-btn-container" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.neverSeeAgain,
                  expression: "neverSeeAgain",
                },
              ],
              staticClass: "check-btn neverSeeAgain",
              attrs: {
                type: "checkbox",
                name: "coach-mark-never-see-again",
                id: "coach-mark-never-see-again",
              },
              domProps: {
                checked: Array.isArray(_vm.neverSeeAgain)
                  ? _vm._i(_vm.neverSeeAgain, null) > -1
                  : _vm.neverSeeAgain,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.neverSeeAgain,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.neverSeeAgain = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.neverSeeAgain = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.neverSeeAgain = $$c
                  }
                },
              },
            }),
            _c(
              "label",
              {
                staticClass: "check-label white",
                attrs: { for: "coach-mark-never-see-again" },
              },
              [_vm._v(_vm._s(_vm.$t("common.never")))]
            ),
          ]),
          _c(
            "button",
            {
              staticClass: "coach-mark-close-btn",
              on: { click: _vm.closeCoachMark },
            },
            [_vm._v(_vm._s(_vm.$t("common.close")))]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "coach-mark-guide-arrow" }, [
      _c("img", {
        attrs: {
          src: require("@/assets/images/coachmark/coachmark_arrow_blue_02.svg"),
          alt: "coach-mark-guide-arrow",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "coach-mark-guide-arrow" }, [
      _c("img", {
        attrs: {
          src: require("@/assets/images/coachmark/coachmark_arrow_blue_05.svg"),
          alt: "coach-mark-guide-arrow",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "coach-mark-guide-arrow" }, [
      _c("img", {
        attrs: {
          src: require("@/assets/images/coachmark/coachmark_arrow_blue_01.svg"),
          alt: "coach-mark-guide-arrow",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "coach-mark-guide-arrow" }, [
      _c("img", {
        attrs: {
          src: require("@/assets/images/coachmark/coachmark_arrow_blue_08.svg"),
          alt: "coach-mark-guide-arrow",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "coach-mark-guide-arrow" }, [
      _c("img", {
        attrs: {
          src: require("@/assets/images/coachmark/coachmark_arrow_blue_06.svg"),
          alt: "coach-mark-guide-arrow",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "coach-mark-guide-arrow" }, [
      _c("img", {
        attrs: {
          src: require("@/assets/images/coachmark/coachmark_arrow_blue_04.svg"),
          alt: "coach-mark-guide-arrow",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "coach-mark-guide-arrow" }, [
      _c("img", {
        attrs: {
          src: require("@/assets/images/coachmark/coachmark_arrow_blue_03.svg"),
          alt: "coach-mark-guide-arrow",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }